import React, { useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';

/**
 * CKEditor, der `data` nur beim Mounten übernimmt.
 *
 * Der React-Wrapper ruft bei jeder Änderung des `data`-Props `editor.data.set()`
 * auf, sobald der Wert vom Editorinhalt abweicht. Wird `data` aus dem State
 * gespeist, den `onChange` schreibt, hinkt der Prop beim Tippen einen
 * Tastendruck hinterher: Der Editor wird auf den alten Stand zurückgesetzt,
 * der Cursor springt an den Anfang und Zeichen landen an der falschen Stelle.
 * Zum Zurücksetzen von außen deshalb `key` ändern (neu mounten).
 */
function StableCKEditor({ data, ...props }) {
  const [initialData] = useState(data);
  return <CKEditor data={initialData} {...props} />;
}

export default StableCKEditor;
